<template>
    <div class="popup">
        <ChangePasswordForm :popup="true" class="popup-inner"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangePasswordForm from '@/components/ChangePasswordForm.vue'

export default {
    name: 'Popup',
    components: {
        ChangePasswordForm
    },
    computed: {
        ...mapGetters(['getUser']),
    },
}
</script>

<style scoped lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

.error_message {
    color: red;
    font-size: 30px;
}
</style>
